export default "__VITE_ASSET__Dmsdk25___"